var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_29_37",
    "data-name": "Component 29 \\u2013 37",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M0,2.005l.532-.533L1.886,2.826,5.892,0l.646.426L2.822,3.063,2.2,3.488l0,0-.356.356Z",
    transform: "translate(4.759 6.625)",
    fill: "#237e17"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_867",
    "data-name": "Ellipse 867",
    fill: "#fff",
    stroke: "#237e17",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.15,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Union_64",
    "data-name": "Union 64",
    transform: "translate(4.759 5.214)",
    fill: "#237e17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.645,5.221l-.095-.1,0,0L0,3.349l.636-.723L2.176,4.379,5.892,0l.646.71L2.824,5.115l.006.007L2.2,5.846Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.195076942443848 5.845857620239258 L 1.550206899642944 5.116487503051758 L 1.551726818084717 5.114067554473877 L -3.129043534499942e-06 3.348797559738159 L 0.6357768774032593 2.625487565994263 L 2.176296949386597 4.378637790679932 L 5.892196655273438 -2.381973217779887e-06 L 6.538577079772949 0.7099876403808594 L 2.824486970901489 5.115277767181396 L 2.830846786499023 5.122547626495361 L 2.195076942443848 5.845857620239258 Z",
    stroke: "none",
    fill: "#237e17"
  }))));
};
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ29tcG9uZW50XzI5XzM3IiBkYXRhLW5hbWU9IkNvbXBvbmVudCAyOSDigJMgMzciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiPg0KICA8cGF0aCBpZD0iVW5pb25fMTUiIGRhdGEtbmFtZT0iVW5pb24gMTUiIGQ9Ik0wLDIuMDA1bC41MzItLjUzM0wxLjg4NiwyLjgyNiw1Ljg5MiwwbC42NDYuNDI2TDIuODIyLDMuMDYzLDIuMiwzLjQ4OGwwLDAtLjM1Ni4zNTZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Ljc1OSA2LjYyNSkiIGZpbGw9IiMyMzdlMTciLz4NCiAgPGcgaWQ9IkVsbGlwc2VfODY3IiBkYXRhLW5hbWU9IkVsbGlwc2UgODY3IiBmaWxsPSIjZmZmIiBzdHJva2U9IiMyMzdlMTciIHN0cm9rZS13aWR0aD0iMS43Ij4NCiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgc3Ryb2tlPSJub25lIi8+DQogICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjcuMTUiIGZpbGw9Im5vbmUiLz4NCiAgPC9nPg0KICA8ZyBpZD0iVW5pb25fNjQiIGRhdGEtbmFtZT0iVW5pb24gNjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuNzU5IDUuMjE0KSIgZmlsbD0iIzIzN2UxNyI+DQogICAgPHBhdGggZD0iTTEuNjQ1LDUuMjIxbC0uMDk1LS4xLDAsMEwwLDMuMzQ5bC42MzYtLjcyM0wyLjE3Niw0LjM3OSw1Ljg5MiwwbC42NDYuNzFMMi44MjQsNS4xMTVsLjAwNi4wMDdMMi4yLDUuODQ2WiIgc3Ryb2tlPSJub25lIi8+DQogICAgPHBhdGggZD0iTSAyLjE5NTA3Njk0MjQ0Mzg0OCA1Ljg0NTg1NzYyMDIzOTI1OCBMIDEuNTUwMjA2ODk5NjQyOTQ0IDUuMTE2NDg3NTAzMDUxNzU4IEwgMS41NTE3MjY4MTgwODQ3MTcgNS4xMTQwNjc1NTQ0NzM4NzcgTCAtMy4xMjkwNDM1MzQ0OTk5NDJlLTA2IDMuMzQ4Nzk3NTU5NzM4MTU5IEwgMC42MzU3NzY4Nzc0MDMyNTkzIDIuNjI1NDg3NTY1OTk0MjYzIEwgMi4xNzYyOTY5NDkzODY1OTcgNC4zNzg2Mzc3OTA2Nzk5MzIgTCA1Ljg5MjE5NjY1NTI3MzQzOCAtMi4zODE5NzMyMTc3Nzk4ODdlLTA2IEwgNi41Mzg1NzcwNzk3NzI5NDkgMC43MDk5ODc2NDAzODA4NTk0IEwgMi44MjQ0ODY5NzA5MDE0ODkgNS4xMTUyNzc3NjcxODEzOTYgTCAyLjgzMDg0Njc4NjQ5OTAyMyA1LjEyMjU0NzYyNjQ5NTM2MSBMIDIuMTk1MDc2OTQyNDQzODQ4IDUuODQ1ODU3NjIwMjM5MjU4IFoiIHN0cm9rZT0ibm9uZSIgZmlsbD0iIzIzN2UxNyIvPg0KICA8L2c+DQo8L3N2Zz4NCg0K";
export { SvgSuccessIcon as ReactComponent };